import { reduce, isNil } from './lodash.utils'

export const sanitizeForForm = <T>(
	defaultVals: any,
	incomingVals?: {
		[x: string]: any
	}
): T => {
	// log('Sanitizing for form | Incoming values: ', incomingVals)
	return reduce(
		defaultVals,
		(obj: any, val, key) => {
			obj[key] = incomingVals && !isNil(incomingVals[key]) ? incomingVals[key] : val

			return obj
		},
		{}
	)
}
